// The doctors an admin can add a clinic schedule for (#42): users with an
// active 'coach' role (the app calls doctors coaches), sorted by Arabic name.

export interface DoctorOption {
  id: string;
  nameAr: string;
  nameEn: string;
}

interface UserLike {
  id: string;
  firstNameAr?: string;
  lastNameAr?: string;
  firstNameEn?: string;
  lastNameEn?: string;
  roles?: { role?: string; isActive?: boolean }[];
}

const full = (a?: string, b?: string) => `${a || ''} ${b || ''}`.trim();

export function activeDoctors(users: UserLike[]): DoctorOption[] {
  return users
    .filter((u) => (u.roles || []).some((r) => r.role === 'coach' && r.isActive === true))
    .map((u) => {
      const nameAr = full(u.firstNameAr, u.lastNameAr);
      const nameEn = full(u.firstNameEn, u.lastNameEn);
      return { id: u.id, nameAr: nameAr || nameEn || u.id, nameEn: nameEn || nameAr || u.id };
    })
    .sort((a, b) => a.nameAr.localeCompare(b.nameAr, 'ar'));
}
